import { Box, Typography, useTheme, Paper, useMediaQuery, Alert } from '@mui/material';
import { tokens } from '../../theme';
import { useTranslation } from 'react-i18next';
import ConstructionIcon from '@mui/icons-material/Construction';

/**
 * Running Traceability Page (Placeholder)
 * Future feature: Visualize GAP matching between FIT workout and GPX course
 */
const RunningTraceability = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const { t } = useTranslation();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <Box m={isMobile ? "10px" : "20px"}>
      {/* Header */}
      <Box mb={3}>
        <Typography variant="h2" fontWeight="bold" color={colors.grey[100]} mb={1}>
          {t('runningTraceability', 'Running Traceability')}
        </Typography>
        <Typography variant="h6" color={colors.grey[300]}>
          {t('gapMatchingVisualization', 'GAP Matching Visualization')}
        </Typography>
      </Box>

      {/* Coming Soon Message */}
      <Paper
        elevation={3}
        sx={{
          backgroundColor: colors.grey[800],
          borderRadius: '8px',
          p: 4,
          textAlign: 'center'
        }}
      >
        <ConstructionIcon
          sx={{
            fontSize: 80,
            color: colors.orangeAccent[500],
            mb: 2
          }}
        />
        <Typography variant="h4" color={colors.grey[100]} mb={2}>
          {t('comingSoon', 'Coming Soon')}
        </Typography>
        <Typography variant="body1" color={colors.grey[300]} mb={3}>
          {t('traceabilityDescription', 'This feature will allow you to visualize how your FIT workout data matches up with a GPX course profile, showing GAP-based matching, cost factors, and elevation correlations.')}
        </Typography>

        {/* Feature List */}
        <Box
          sx={{
            textAlign: 'left',
            maxWidth: 600,
            mx: 'auto',
            mt: 3
          }}
        >
          <Typography variant="h6" color={colors.grey[100]} mb={2}>
            {t('plannedFeatures', 'Planned Features')}
          </Typography>
          <Typography variant="body2" color={colors.grey[300]} mb={1}>
            • Grade-Adjusted Pace (GAP) matching between workout and course
          </Typography>
          <Typography variant="body2" color={colors.grey[300]} mb={1}>
            • Cost factor visualization (how gradient affects pace)
          </Typography>
          <Typography variant="body2" color={colors.grey[300]} mb={1}>
            • Elevation profile correlation
          </Typography>
          <Typography variant="body2" color={colors.grey[300]} mb={1}>
            • Segment-by-segment pace analysis
          </Typography>
          <Typography variant="body2" color={colors.grey[300]} mb={1}>
            • Interactive map with matched points
          </Typography>
        </Box>
      </Paper>

      {/* Info Alert */}
      <Alert severity="info" sx={{ mt: 3 }}>
        {t('traceabilityNote', 'Running traceability works similarly to bike power matching, but uses GAP (Grade-Adjusted Pace) instead of power for more accurate course-to-workout correlation.')}
      </Alert>
    </Box>
  );
};

export default RunningTraceability;
